import { useEffect, useState } from 'react';
import type { PropsWithChildren } from 'react';
import useIsMountedRef from '@/services/useIsMountedRef.ts';

// Use a show enough delay here that the user wont care, but long enough for most loading to finish
const DEFAULT_DELAY_MS = 300;

export type DelayedProps = PropsWithChildren<{
    delay?: number;
}>;

export function Delayed({ delay = DEFAULT_DELAY_MS, children }: DelayedProps) {
    const [isVisible, setIsVisible] = useState(false);
    const isMountedRef = useIsMountedRef();

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (isMountedRef.current) {
                setIsVisible(true);
            }
        }, delay);
        return () => {
            clearTimeout(timeout);
        };
    }, [delay, isMountedRef]);

    if (!isVisible) {
        return null;
    }
    return <>{children}</>;
}
